<div class="d-flex justify-content-end">
  <button type="submit" [disabled]="yesButton" class="btn btn-primary" (click)="onConfirm.emit()">{{ yes }}</button>
  <button type="button" [disabled]="noButton" class="btn btn-secondary ml-2" (click)="onCancel.emit()">{{ no }}</button>
</div>
